export const AI_HELP_RESERVED_SPACE_CSS_VAR = '--ai-help-reserved-space'
export const AI_HELP_RESERVED_SPACE_EVENT = 'ai-help-reserved-space-change'

export const AI_HELP_YARL_STYLES = {
  root: {
    right: `var(${AI_HELP_RESERVED_SPACE_CSS_VAR}, 0px)`,
    zIndex: 10000
  }
} as const

export const readAiHelpReservedSpacePx = () => {
  if (typeof window === 'undefined') return 0

  const cssValue = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(AI_HELP_RESERVED_SPACE_CSS_VAR)
  const parsed = parseFloat(cssValue)
  return Number.isFinite(parsed) ? Math.max(0, parsed) : 0
}
